const THROTTLE = 100;

const requestQueue = [];
let i = -1;
let intervalId = null;

export function queueRequest(reqFunc, dontThrottle) {
  if (dontThrottle) {
    reqFunc && reqFunc();
    return;
  }

  requestQueue.push(reqFunc);
  _run();
}

function _run() {
  if (intervalId || !requestQueue.length) return;

  _executeRequest();
  intervalId = setInterval(_executeRequest, THROTTLE);
}

function _stop() {
  clearInterval(intervalId);
  intervalId = null;
  i = -1;
  requestQueue.length = 0;
}

function _executeRequest() {
  i++;

  if (i > requestQueue.length - 1) {
    _stop();
    return;
  }

  const reqFunc = requestQueue[i];
  reqFunc && reqFunc();
}
